import { SR_API_ACTION_APARTMENT_LOCATOR_GET_MAX_LEADS_STATUS } from 'api/actionTypes';

export default async function getMaxLeadsStatus({ state, apiClient }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_GET_MAX_LEADS_STATUS,
    state: state,
    onSuccess(maxLeadsStatus) {
      state.set(['apartmentLocator', 'maxLeadsStatus'], maxLeadsStatus);
      return maxLeadsStatus;
    },
  });
}
